import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';

export const isValidPosition = (lat?: number, lng?: number) => {
  if (!lat || !lng) return false;
  return !(!isValidLatitude(lat) || !isValidLongitude(lng));
};
